<template>
<div class=careworkers>
  <loginUsersList></loginUsersList>
  <router-view></router-view>
</div>
</template>

<script>
import loginUsersList from './loginUsersList.vue'

export default {
  components: {
    loginUsersList
  }
}
</script>
<style scoped>
.careworkers {
  height: 100%;
  overflow-wrap: anywhere;
}
</style>



// WEBPACK FOOTER //
// src/components/loginUsers/loginUsers.vue